<template>
  <v-list
    nav
  >
    <v-list-item
      :to="{ name: 'Membership' }"
    >
      <v-list-item-icon>
        <v-icon>preview</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>MSA Membership</v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-list-item
      :to="{ name: 'MemberPeople' }"
    >
      <v-list-item-icon>
        <v-icon>manage_accounts</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>User Accounts</v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-list-item
      v-show="isMemberAdmin"
      :to="{ name: 'MemberTraineesReport', query: { memberNumber: this.selectedMemberNumber } }"
    >
      <v-list-item-icon>
        <v-icon>verified</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>User Training Status</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

import { getters } from '../store'

export default {
  name: 'UserNavigation',

  computed: {
    ...mapState([
      'selectedMemberNumber'
    ]),
    ...mapGetters([
      getters.IS_ADMIN_FOR_REGISTRATION
    ]),
    isMemberAdmin  () {
      return this[getters.IS_ADMIN_FOR_REGISTRATION]
    }
  },

  methods: {
    openTraineeReport () {
      this.$router.push({
        name: 'MemberTraineesReport',
        query: {
          memberNumber: this.selectedMemberNumber
        }
      })
    }
  }
}
</script>
